<template>
  <div id="table-of-contents"
       ref="tab">
    <treeGrid ref="treeGrid"
              sum-text="sum"
              index-text="#"
              :data="tableOfContents"
              :columns="columns"
              :stripe="props.stripe"
              :border="props.border"
              :show-header="props.showHeader"
              :show-summary="props.showSummary"
              :show-row-hover="props.showRowHover"
              :show-index="props.showIndex"
              :tree-type="props.treeType"
              :empty-text="'No Data'"
              :is-fold="props.isFold"
              :expand-type="props.expandType"
              :selection-type="props.selectionType">
      <template #add="scope">
        <div class="cursor-pointer"
             @click="showModal(scope.row)"
             v-b-modal.export>
          <b-icon class="cursor-pointer"
                  scale="2"
                  variant="secondary"
                  icon="plus-square-fill"
                  sm/>
        </div>
      </template>
      <template #del="scope">
        <div class="cursor-pointer"
             @click="deleteChild(scope.row)">
          <b-icon class="cursor-pointer"
                  scale="2"
                  variant="secondary"
                  icon="dash-square-fill"
                  sm/>
        </div>
      </template>
      <template #status="scope">
        <span class="status-tag btn"
              v-if="scope.row.status"
              :class="getStatusTagClass(scope.row.status)"
              style="font-size:11px;"
              @click="showContentDetail(scope.row.contentId)">
          {{ scope.row.status | formatStatus }}
          <b-icon icon="box-arrow-up-right"
                  style="height:0.7em; margin-left:0.2em; "
                  :class="getStatusTagClass(scope.row.status)"/>
        </span>
      </template>
      <template #assignee="scope">
        <b-select id="assignee"
                  size="sm"
                  class="custom-input in-grid-input"
                  :options="members"
                  v-model="scope.row.assignee"
                  @change="setVal(scope.row, 'assignee', scope.row.assignee)"
                  style="font-size:1em; padding: 0.2px 0.2px 0.2px 17.1px; "/>
      </template>
      <template #startDate="scope">
        <b-input-group class="form-inline">
          <b-form-input id="start-date"
                        name="start-date"
                        type="date"
                        v-model="scope.row.startDate"
                        size="sm"
                        class="custom-input in-grid-input  rounded"
                        data-vv-as="start date"
                        placeholder="YYYY-MM-DD"
                        style="font-size:1em; text-align:center;"
                        @change="setVal(scope.row, 'startDate', scope.row.startDate)"></b-form-input>
        </b-input-group>
      </template>
      <template #endDate="scope">
        <b-input-group class="form-inline">
          <b-form-input id="end-date"
                        name="end-date"
                        type="date"
                        v-model="scope.row.endDate"
                        size="sm"
                        class="custom-input in-grid-input rounded"
                        data-vv-as="end date"
                        placeholder="YYYY-MM-DD"
                        style="font-size:1em; text-align:center;"
                        @change="setVal(scope.row, 'endDate', scope.row.endDate)"></b-form-input>
        </b-input-group>
      </template>
    </treeGrid>
    <b-input-group>
      <!-- Lv 1 creation button -->
      <esg-base-button variant="primary"
                       class="mt-3"
                       size="sm"
                       style="width: 100px"
                       @click="showModal(null)">추가
      </esg-base-button>
      <!-- /Lv 1 creation button -->
    </b-input-group>

    <!-- New content creation modal -->
    <b-modal ref="newStepModal"
             id="new-step"
             :hide-header="true"
             :hide-footer="true"
             size="md">
      <div style="padding : 1em;">
        <b-form-row>
          <b-col>
            <label for="step">목차</label>
            <b-input id="step"
                     size="sm"
                     class="custom-input"
                     v-model="newStep.label"/>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <label for="assignee">담당자</label>
            <b-form-select v-model="newStep.assignee"
                           class="assignee mt-1">
              <option v-for="option in members"
                      :key="option.value"
                      :value="option.value">
                {{ option.text }}
              </option>
            </b-form-select>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <label for="startDate">시작일</label>
            <b-form-input id="start-date"
                          name="start-date"
                          type="date"
                          v-model="newStep.startDate"
                          size="sm"
                          class="custom-input in-grid-input  rounded"
                          data-vv-as="start date"
                          placeholder="YYYY-MM-DD"
                          style="font-size:1em; text-align:left;"></b-form-input>
          </b-col>
          <b-col>
            <label for="endDate">종료일</label>
            <b-form-input id="end-date"
                          name="end-date"
                          type="date"
                          v-model="newStep.endDate"
                          size="sm"
                          class="custom-input in-grid-input rounded"
                          data-vv-as="end date"
                          placeholder="YYYY-MM-DD"
                          style="font-size:1em; text-align:left;"></b-form-input>
          </b-col>
        </b-form-row>

        <b-form-row>
          <b-col>
            <label for="description">설명</label>
            <b-form-input id="description"
                          name="description"
                          size="sm"
                          class="custom-input  rounded"
                          v-model="newStep.description"></b-form-input>
          </b-col>
        </b-form-row>

        <b-form-row>
          <b-col>
            <label for="gri">GRI</label>
            <b-form-group id="gri">
              <b-form-select v-model="newStep.griLv1"
                             class="mt-1">
                <option v-for="option in getGriOptions(1)"
                        :key="option"
                        :value="option">
                  {{ option }}
                </option>
              </b-form-select>
              <b-form-select v-if="newStep.griLv1"
                             v-model="newStep.griLv2"
                             class="mt-1">
                <option v-for="option in getGriOptions(2)"
                        :key="option">
                  {{ option }}
                </option>
              </b-form-select>
              <b-form-select v-if="newStep.griLv2"
                             v-model="newStep.griLv3"
                             class="mt-1">
                <option v-for="option in getGriOptions(3)"
                        :key="option"
                        :value="option">
                  {{ option }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-form-row>
      </div>
      <esg-base-button variant="primary"
                       @click="addChild()">생성
      </esg-base-button>
    </b-modal>
    <!-- New content creation modal -->
  </div>
</template>
<script>
import treeGrid from 'vue-table-with-tree-grid'
import griData from '../model/gri.json'
import EsgBaseButton from "@/components/esg/base/EsgBaseButton.vue";
import { v4 as uuid } from "uuid"

export default {
  name: "EsgTocTemplateManagementGrid",
  props: {
    tableOfContents: {
      type: Array,
      required: true,
    },
    deletedItems: {
      type: Array,
      required: false,
    },
    members: {
      type: Array,
      required: true,
    }
  },
  components: {
    EsgBaseButton,
    treeGrid
  },
  data() {
    return {
      props: {
        stripe: false,
        border: false,
        showHeader: true,
        showSummary: false,
        showRowHover: false,
        showIndex: false,
        treeType: true,
        isFold: false,
        expandType: false,
        selectionType: false,
      },
      newStep: {},
      columns: [
        {
          label: "목차",
          type: "template",
          template: "phase",
          width: "300px",
          prop: "label",
          headerAlign: "center",
        },
        {
          label: "",
          width: "30px",
          type: "template",
          template: "add",
          headerAlign: "center",
          align: "center"
        },
        {
          label: "",
          width: "30px",
          type: "template",
          template: "del",
          headerAlign: "center",
          align: "left"
        },
        {
          label: '상태',
          type: "template",
          template: "status",
          width: "110px",
          prop: "status",
          headerAlign: "center",
          align: "center"
        },
        {
          label: "ESG",
          width: "55px",
          prop: "griLv1",
          headerAlign: "center",
          align: "center"
        },
        {
          label: "GRI 공시 기준",
          width: "190px",
          prop: "griLv2",
          headerAlign: "center",
          align: "left"
        },
        {
          label: "GRI 세부 지표",
          width: "220px",
          prop: "griLv3",
          headerAlign: "center",
          align: "left"
        },
        {
          label: "설명",
          width: "150px",
          prop: "description",
          headerAlign: "center",
          align: "left"
        },
        {
          label: "담당자",
          type: "template",
          template: "assignee",
          width: "110px",
          prop: "assignee",
          headerAlign: "center",
          align: "left"
        },
        {
          label: "시작일",
          prop: "startDate",
          width: "145px",
          headerAlign: "center",
          align: "center",
          type: 'template',
          template: 'startDate',
        },
        {
          label: "종료일",
          prop: "endDate",
          width: "145px",
          headerAlign: "center",
          align: "center",
          type: 'template',
          template: 'endDate',
        },
      ],
      componentKey: 'No Data',
    };
  },
  created() {
    this.$store.dispatch('report/retrieveUsers');
  },
  watch: {
    data: {
      handler() {
        if (!this.tableOfContents[0].status) {
          this.columns = this.columns.filter(obj => obj.label !== '상태')
        }
      },
      deep: true,
      immediate: false,
    }
  },
  methods: {
    showContentDetail(contentId) {
      this.pushRoute({ name: "EsgDisclosureContentDetail", params: { id: contentId } });
    },
    setVal(obj, property, val) {
      const target = this.findById(this.tableOfContents, obj.id);
      target[property] = val;
      target.updated = true;
    },
    generateId() {
      return uuid();
    },
    showModal(obj) {
      this.newStep = {
        id: this.generateId(),
        label: '',
        parent: obj,
        description: '',
        order: null,
        griLv1: '',
        griLv2: '',
        griLv3: '',
        startDate: null,
        endDate: null,
        assignee: null,
        children: [],
        status: 'to_do',
        created: true,
        updated: false
      }
      this.$refs['newStepModal'].show();
    },
    addChild() {
      this.$refs['newStepModal'].hide();
      const parent = this.newStep.parent;
      if (parent) {
        parent.children.push(this.newStep);
      } else {
        this.tableOfContents.push(this.newStep);
      }
    },
    deleteChild(target) {
      if (target.parent) {
        const children = target.parent.children;
        const indexToRemove = children.findIndex(child => child.id === target.id)
        this.deletedItems && this.deletedItems.push(children[indexToRemove].id);
        children.splice(indexToRemove, 1);
      } else if (target.parentId) {
        const parent = this.findById(this.tableOfContents, target.parentId);
        const indexToRemove = parent.children.findIndex(child => child.id === target.id)
        this.deletedItems && this.deletedItems.push(parent.children[indexToRemove].id);
        parent.children.splice(indexToRemove, 1);
      } else {
        const indexToRemove = this.tableOfContents.findIndex(child => child.id === target.id)
        this.deletedItems && this.deletedItems.push(this.tableOfContents[indexToRemove].id);
        this.tableOfContents.splice(indexToRemove, 1);
      }
    },
    findById(root, id) {
      if (!root) return null;
      let children = root;
      if (typeof root === 'object' && root.children) {
        if (root.id === id) return root;
        children = root.children;
      }
      for (const child of children) {
        const result = this.findById(child, id);
        if (result) return result;
      }
      return null;
    },
    getGriOptions(lv) {
      let tempData = griData;
      if (lv > 1) {
        let parentLv = 'griLv' + (lv - 1);
        tempData = tempData.filter(obj => obj[parentLv] === this.newStep[parentLv])
      }
      let targetLv = 'griLv' + lv;
      tempData = tempData.map(obj => obj[targetLv])
      return Array.from(new Set(tempData))
    },
    getStatusTagClass(status) {
      return status ? status.replace('_', '-').toLowerCase() : null;
    },
  },
  filters: {
    formatStatus(strStatus) {
      if (!strStatus) return null;

      let arrStrStatus = strStatus.split("_");
      let result = '';
      for (let i in arrStrStatus) {
        let str = arrStrStatus[i]
        result = result + " " + str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      }
      return result
    },
  }
};
</script>

<style>
#table-of-contents .custom-select {
  background-position: calc(100% - 6px) 5px !important;
}

#table-of-contents .btn {
  height: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
}

#table-of-contents .status-tag {
  max-width: 100px;
  width: 100%;
  height: 29px;
  padding: 4px 6px;
  border-radius: 38px;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 11px;
  font-weight: 500;
  line-height: 150%;
  white-space: nowrap;
  padding: 1em;
  overflow: hidden;
  /* 텍스트 오버플로우 숨김 */
  text-overflow: ellipsis;
  /* 텍스트 초과 시 ellipsis 표시 */
}

#table-of-contents .status-tag.in-progress {
  background-color: #F5ECD6;
  color: #FF5C00;
}

#table-of-contents .status-tag.in-progress-red {
  background-color: #F5D6D6;
  color: #F00;
}

#table-of-contents .status-tag.to-do {
  background-color: #F6F6FA;
  color: #2E2E38;
}

#table-of-contents .status-tag.done {
  background-color: #CFDDFF;
  color: #1755CC;
}

#table-of-contents .status-tag.closed {
  background-color: #D7F5D6;
  color: #168D4C;
}

#table-of-contents .status-tag.cancelled {
  background-color: #E4E4EA;
  color: rgba(116, 116, 128, 0.70);
}

#table-of-contents input#start-date,
#table-of-contents input#end-date,
#table-of-contents select#assignee.custom-select {
  height: 30px !important;
  margin-bottom: 0;
}

.cursor-pointer {
  cursor: pointer;
}
</style>

<style scoped>
>>> .btn {
  height: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
}

>>> .modal-dialog {
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

>>> .modal-body button {
  width: 100%;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

>>> .modal-body {
  padding: 0;
}

>>> .modal-content,
>>> .modal-body {
  border-radius: 10px;
}

>>> .modal-body select.custom-select {
  -o-appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 2rem;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
